import React, { useEffect, useState } from 'react';
import {
  Col, Input, FormGroup, FormText,
} from 'reactstrap';

const BackgroundImage = ({
  awsImage,
  setImage,
  title,
}) => {
  const [errorImage, setErrorImage] = useState(null);

  useEffect(() => {
    onImagesUpload({
      target: {
        files: [
          awsImage,
        ],
      },
      isFromAws: true,
    });
  }, [awsImage]);

  const onImagesUpload = async ({ target: { files }, isFromAws = false }) => {
    if (!files[0]) {
      return;
    }

    const response = await fetch(files[0]);
    const data = await response.blob();

    setErrorImage(null);
    setImage(null);

    if (files[0].size > 2 * 1024 * 1024) {
      setErrorImage('Uploaded image is more than 2 Mo.');
      return;
    }

    const reader = new FileReader();
    const image = new Image();

    image.crossOrigin = 'anonymous';

    image.onload = () => {
      if (image.height === 960 && image.width === 1280) {
        setImage(image.src);
      } else {
        setErrorImage("Uploaded image doesn't meet size requirements.");
      }
    };
    reader.onloadend = () => {
      image.src = reader.result;
    };

    reader.readAsDataURL(isFromAws ? data : files[0]);
  };

  return (
    <Col className="section_form_template">
      <h4>{title}</h4>
      <FormGroup>
        <Input type="file" name="background" accept="image/*" onChange={onImagesUpload} />
        <FormText color="muted">
          Uploaded image should be less than 1 Mo and sized 1280x960.
        </FormText>
        {errorImage && (
          <FormText color="danger">
            {errorImage}
          </FormText>
        )}
      </FormGroup>
    </Col>
  );
};

export default BackgroundImage;



// WEBPACK FOOTER //
// ./src/components/templates/backgroundImage.js